import { INudosTransfDetailsData } from '../../types/paymentDetails';
import { NudosGenericModal } from '../NudosComponents';
import PaymentDetailsModalContent from './PaymentDetailsModalContent';
import NudosModalContent from '../NudosComponents/NudosModalContent/NudosModalContent';
import './PaymentDetailsModal.scss';

const PaymentDetailsModal = ({
  paymentDetailsModalData,
  closeModalCallback
}: {
  paymentDetailsModalData?: INudosTransfDetailsData;
  closeModalCallback: () => void;
}) => {
  return (
    <div id="paymentDetailsModal">
      <NudosGenericModal
        closeModalCallback={closeModalCallback}
        modalContent={
          <NudosModalContent
            hideNudosIcon
            noScroll
            customWidth="680px"
            customHeight="480px"
            toCloseModal={closeModalCallback}
            modalContentTitle="Datos de pago"
            modalContentSubtitle="Estos son los datos que visualiza el usuario"
            CustomModalComponent={
              <PaymentDetailsModalContent
                paymentDetailsModalData={paymentDetailsModalData}
                closeModalCallback={closeModalCallback}
              />
            }
          />
        }
      />
    </div>
  );
};

export default PaymentDetailsModal;
